
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { PROVIDER } from 'src/environments/config';

@Injectable({ providedIn: 'root' })
export class LocationService {
    private URL = ''

    constructor(
        private http: HttpClient) {
        this.URL = environment.domain
    }

    getCountryCb() {
        const url_api = this.URL + 'api/em/country/get_cb'
        return this.http.get(url_api);
    }

    getDepartmentComboCountry(code: string) {
        const url_api = this.URL + 'api/em/location_one/get_cb_filter/country/' + code
        return this.http.get(url_api);
    }

    getCityComboDepartment(code: string) {
        const url_api = this.URL + 'api/em/location_two/get_cb_filter/location_one/' + code
        return this.http.get(url_api);
    }

    getCityCb() {
        const url_api = this.URL + 'api/em/location_two/get_cb' + (PROVIDER.providerId == null ? '' : ('/' + PROVIDER.providerId))
        return this.http.get(url_api);
    }

    getDistrictComboCity(code: string) {
      const url_api = this.URL + 'api/em/location_three/get_cb_filter/location_two/' + code
      return this.http.get(url_api);
    }

    getValidateActiveCity(code:any) {
      const url_api = this.URL + 'api/em/location_two/get/' + code
      return this.http.get(url_api);
    }

    getZoneServerSideOne(id:any){
      const url_api = this.URL + 'api/em/location_zone/get/'+id
      return this.http.get(url_api)
    }
}
